import React, { useState } from 'react';
import classnames from 'classnames/bind';
import { MessageSquarePlus, X } from 'lucide-react';

import { CommentContextMenuPosition, CommentSelection } from '@INTERFACES/comments';

import styles from './CommentContextMenu.module.scss';

const cx: CX = classnames.bind(styles);

interface Props {
    position: CommentContextMenuPosition;
    onCreateComment: (selection: CommentSelection, commentText: string) => void;
    onClose: () => void;
}

export default function CommentContextMenu({ position, onCreateComment, onClose }: Props) {
    const [commentText, setCommentText] = useState('');
    const [isExpanded, setIsExpanded] = useState(false);

    if (!position.visible || !position.selection) {
        return null;
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (commentText.trim()) {
            onCreateComment(position.selection!, commentText.trim());
            setCommentText('');
            setIsExpanded(false);
            onClose();
        }
    };

    const handleAddComment = () => {
        setIsExpanded(true);
    };

    const handleCancel = () => {
        setCommentText('');
        setIsExpanded(false);
        onClose();
    };

    return (
        <div
            className={cx('comment-context-menu')}
            style={{
                position: 'fixed',
                left: position.x,
                top: position.y,
                zIndex: 10000,
            }}
        >
            {!isExpanded ? (
                <button
                    type="button"
                    className={cx('comment-trigger')}
                    onClick={handleAddComment}
                    title="Add comment"
                >
                    <MessageSquarePlus size={16} />
                    <span>Add comment</span>
                </button>
            ) : (
                <div className={cx('comment-form')}>
                    <div className={cx('selected-text')}>
                        &ldquo;{position.selection.text}&rdquo;
                    </div>
                    <form onSubmit={handleSubmit}>
                        <textarea
                            value={commentText}
                            onChange={(e) => setCommentText(e.target.value)}
                            placeholder="Add a comment..."
                            className={cx('comment-input')}
                            rows={3}
                        />
                        <div className={cx('form-actions')}>
                            <button
                                type="button"
                                onClick={handleCancel}
                                className={cx('cancel-button')}
                            >
                                <X size={14} />
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={!commentText.trim()}
                                className={cx('submit-button')}
                            >
                                Comment
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
} 